import { z } from 'zod'

export const QRImageDataSchema = z.object({
  enrollment_code: z.string(),
  qr_standard: z.string(),
  qr_huawei: z.string(),
  raw_config: z.string()
})

export type QRImageData = z.infer<typeof QRImageDataSchema>
